import { LocalParticipant, LocalTrack } from "livekit-client";
import { useCallback } from "react";

export function useTrackPublication(localParticipant?: LocalParticipant) {
  return useCallback(
    async (track?: LocalTrack | MediaStreamTrack, publish?: boolean) => {
      const participant = localParticipant;
      if (!participant || !track) return;
      try {
        if (publish) await participant.publishTrack(track);
        else await participant.unpublishTrack(track);

        // publish
        //   ? await participant.publishTrack(track)
        //   : await participant.unpublishTrack(track);
      } catch {
        /* duplicate publish/unpublish → نادیده بگیر */
      }
    },
    [localParticipant]
  );
}
